export default function isScrolled($parse) {
  'ngInject';

  return function link($scope, $element, $attrs) {
    const assign = $parse($attrs.isScrolled).assign;
    let currentValue = false;

    function setValue(value) {
      if (value !== currentValue) {
        $scope.$evalAsync(() => {
          assign($scope, value);
        });

        currentValue = value;
      }
    }

    $element.on('scroll', () => {
      if ('isScrolledType' in $attrs) {
        if ($attrs.isScrolledType === 'x') {
          setValue($element[0].scrollLeft > 0);
        } else if ($attrs.isScrolledType === 'y') {
          setValue($element[0].scrollTop > 0);
        }
      } else {
        setValue($element[0].scrollLeft > 0 || $element[0].scrollTop > 0);
      }
    });
  };
}
